import { Dropdown } from 'semantic-ui-react';
import { countries } from 'modules/get-country-name/countries';
import { useField } from 'formik';
import FieldWrapper from 'components/Form/Fields/FieldWrapper';

export default function CountryCodeField({ label, ...props }) {
  const [field, meta] = useField(props);

  return (
    <FieldWrapper props={props} meta={meta} label={label}>
      <Dropdown
        {...field}
        {...props}
        className="form-field__dropdown"
        placeholder="Selecciona País"
        fluid
        search
        selection
        options={countries}
        searchInput={{ autoComplete: 'new-password', id: 'country-code-field' }}
      />
    </FieldWrapper>
  );
}
